import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class ViewInvoice<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags View Invoice
	 * @name OrderInvoiceDetail
	 * @summary View order invoices details.
	 * @request GET:/store/{storeId}/order/invoice
	 * @secure
	 * @response `200` `(string)[]` Invoices returned successfully as an array of strings.
	 * @response `400` `void` Bad request.
	 * @response `401` `void` Not authenticated.
	 * @response `403` `void` Forbidden.
	 * @response `404` `void` Not found.
	 * @response `500` `void` Internal server error.
	 */
	orderInvoiceDetail = (
		storeId: string,
		query: {
			/** The order IDs. */
			orderIds: string[];
			/** The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json. */
			responseFormat?: 'json' | 'xml';
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['orderInvoiceDetail'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/order/invoice`,
				params: _params,
				query: query,
				methodName: 'orderInvoiceDetail',
			};
			logger.trace(traceData);
		}
		return this.http.request<string[], void>({
			path: `/store/${storeId}/order/invoice`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags View invoice
	 * @name OrderInvoiceDetail2
	 * @summary View order invoice details.
	 * @request GET:/store/{storeId}/order/{orderId}/invoice/{invoiceId}
	 * @originalName orderInvoiceDetail
	 * @duplicate
	 * @secure
	 * @response `200` `File` PDF invoice returned successfully.
	 * @response `400` `void` Bad request.
	 * @response `401` `void` Not authenticated.
	 * @response `403` `void` Forbidden.
	 * @response `404` `void` Not found.
	 * @response `500` `void` Internal server error.
	 */
	orderInvoiceDetail2 = (
		storeId: string,
		orderId: string,
		invoiceId: string,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['orderInvoiceDetail2'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/order/${orderId}/invoice/${invoiceId}`,
				params: _params,
				methodName: 'orderInvoiceDetail2',
			};
			logger.trace(traceData);
		}
		return this.http.request<File, void>({
			path: `/store/${storeId}/order/${orderId}/invoice/${invoiceId}`,
			method: 'GET',
			secure: true,
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
